import React, { ReactElement } from "react";

import OpenPosition from "components/OpenPosition";

import { OpenPositions } from "./OpenPositionList.styled";
import OpenPositionListProps from "./OpenPositionListProps";

const OpenPositionList = ({
    identifier,
    items,
    className,
}: OpenPositionListProps): ReactElement => {
    return (
        <OpenPositions
            key={identifier || `OpenPositionListContent`}
            className={className}
        >
            {items?.map((item, index) => {
                return <OpenPosition key={`OpenPosition${index}`} {...item} />;
            })}
        </OpenPositions>
    );
};

export default React.memo(OpenPositionList);
